import React from 'react';
import { Card, Title, Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell, Button, Badge } from '@tremor/react';

export function NotificationsPage() {
  const notifications = [
    { 
      id: 1, 
      event: 'Overdue Repair', 
      condition: 'repairQueue > 100 items', 
      channel: 'Email', 
      status: 'Active' 
    },
    { 
      id: 2, 
      event: 'Low Inventory', 
      condition: 'inventory level < 10', 
      channel: 'Slack', 
      status: 'Active' 
    },
    { 
      id: 3, 
      event: 'Failed Integration', 
      condition: 'API error rate > 5%', 
      channel: 'Email, Slack', 
      status: 'Inactive' 
    }
  ];

  const getStatusBadge = (status) => {
    return (
      <Badge color={status === 'Active' ? 'green' : 'gray'}>
        {status}
      </Badge>
    );
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <Title>Notification Rules</Title>
        <Button>+ New Rule</Button>
      </div>

      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeaderCell>Event</TableHeaderCell>
              <TableHeaderCell>Condition</TableHeaderCell>
              <TableHeaderCell>Channel</TableHeaderCell>
              <TableHeaderCell>Status</TableHeaderCell>
              <TableHeaderCell>Actions</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notifications.map(notification => (
              <TableRow key={notification.id}>
                <TableCell>{notification.event}</TableCell>
                <TableCell>{notification.condition}</TableCell>
                <TableCell>{notification.channel}</TableCell>
                <TableCell>{getStatusBadge(notification.status)}</TableCell>
                <TableCell>
                  <div className="space-x-2">
                    <Button size="xs" variant="secondary">Edit</Button>
                    <Button 
                      size="xs" 
                      variant="secondary"
                      color={notification.status === 'Active' ? 'red' : 'green'}
                    >
                      {notification.status === 'Active' ? 'Deactivate' : 'Activate'}
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}